const CompareCleaningRobots = () => {
  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Compare <span className="text-primary">Cleaning Robots</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          PUDU CR Gen 1 Product Map - Choose the perfect cleaning solution for your facility.
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-[hsl(var(--line))]">
              <th className="text-left p-4 font-orbitron font-bold">Specification</th>
              <th className="text-center p-4 font-orbitron font-bold">CC1</th>
              <th className="text-center p-4 font-orbitron font-bold">CC1 Pro</th>
              <th className="text-center p-4 font-orbitron font-bold">MT1</th>
              <th className="text-center p-4 font-orbitron font-bold">MT1 Vac</th>
              <th className="text-center p-4 font-orbitron font-bold">MT1 Max</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Product Size</td>
              <td className="p-4 text-center text-sm">629×552×695 mm</td>
              <td className="p-4 text-center text-sm">629×552×695 mm</td>
              <td className="p-4 text-center text-sm">840×610×490 mm</td>
              <td className="p-4 text-center text-sm">840×600×490 mm</td>
              <td className="p-4 text-center text-sm">840×600×675 mm</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Trash Box Capacity</td>
              <td className="p-4 text-center text-sm">0.45L / 1.2L</td>
              <td className="p-4 text-center text-sm">0.45L / 1.2L</td>
              <td className="p-4 text-center text-sm">35L</td>
              <td className="p-4 text-center text-sm">6L</td>
              <td className="p-4 text-center text-sm">35L</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Dust Bag Capacity</td>
              <td className="p-4 text-center text-sm">2.5L / 6L</td>
              <td className="p-4 text-center text-sm">2.5L / 6L</td>
              <td className="p-4 text-center text-sm">-</td>
              <td className="p-4 text-center text-sm">14L</td>
              <td className="p-4 text-center text-sm">-</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Cleaning Function</td>
              <td className="p-4 text-center text-sm">Sweeping, Scrubbing, Vacuuming, Dust Mopping</td>
              <td className="p-4 text-center text-sm">Sweeping, Scrubbing, Vacuuming, Dust Mopping</td>
              <td className="p-4 text-center text-sm">Sweeping</td>
              <td className="p-4 text-center text-sm">Sweeping, Vacuuming, Dust Mopping</td>
              <td className="p-4 text-center text-sm">Sweeping</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Standard Runtime (Medium Mode)</td>
              <td className="p-4 text-center text-sm">3h</td>
              <td className="p-4 text-center text-sm text-primary font-bold">3.5h</td>
              <td className="p-4 text-center text-sm">6h</td>
              <td className="p-4 text-center text-sm">4h</td>
              <td className="p-4 text-center text-sm text-primary font-bold">8h</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Default Speed</td>
              <td className="p-4 text-center text-sm">0.5m/s</td>
              <td className="p-4 text-center text-sm text-primary font-bold">0.8m/s</td>
              <td className="p-4 text-center text-sm">0.8m/s</td>
              <td className="p-4 text-center text-sm">0.8m/s</td>
              <td className="p-4 text-center text-sm">0.8m/s</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Cleaning Efficiency (default speed)</td>
              <td className="p-4 text-center text-sm">450m²/h</td>
              <td className="p-4 text-center text-sm">700m²/h</td>
              <td className="p-4 text-center text-sm">1450m²/h</td>
              <td className="p-4 text-center text-sm">1100m²/h</td>
              <td className="p-4 text-center text-sm">1450m²/h</td>
            </tr>
            <tr className="border-b border-[hsl(var(--line))] hover:bg-white/5">
              <td className="p-4 font-semibold">Total Cleaning Area (per charge)</td>
              <td className="p-4 text-center text-sm">1350m²</td>
              <td className="p-4 text-center text-sm">2450m²</td>
              <td className="p-4 text-center text-sm">8700m²</td>
              <td className="p-4 text-center text-sm">4400m²</td>
              <td className="p-4 text-center text-sm">11600m²</td>
            </tr>
            <tr className="hover:bg-white/5">
              <td className="p-4 font-semibold">Floor Area Cleaned (per charge)</td>
              <td className="p-4 text-center text-sm">3375m²</td>
              <td className="p-4 text-center text-sm">6125m²</td>
              <td className="p-4 text-center text-sm">21750m²</td>
              <td className="p-4 text-center text-sm">11000m²</td>
              <td className="p-4 text-center text-sm">29000m²</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-8">
        <p className="text-sm text-muted-foreground mb-4">
          All PUDU cleaning robots feature advanced AI navigation, obstacle avoidance, and autonomous operation.
        </p>
      </div>
    </section>
  );
};

export default CompareCleaningRobots;
